import { render, staticRenderFns } from "./AddToAlbumModal.vue?vue&type=template&id=148c6704&scoped=true"
import script from "./AddToAlbumModal.vue?vue&type=script&lang=ts"
export * from "./AddToAlbumModal.vue?vue&type=script&lang=ts"
import style0 from "./AddToAlbumModal.vue?vue&type=style&index=0&id=148c6704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c6704",
  null
  
)

export default component.exports